<template>
  <div class="ship-info-container">
    <!-- <span class="label">{{ currentName }}</span>
    <img class="ship-info-icon"
         src="../../assets/png/ship-info-2x.png" /> -->
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import {
  Cartesian2,
  Cartesian3,
  NearFarScalar,
  Color,
  PolylineOutlineMaterialProperty,
  HorizontalOrigin,
  VerticalOrigin,
  Math,
  PolylineDashMaterialProperty
} from 'cesium';
import { CustomPopup } from '@/lib/layer'
import store from '@/store/index';
import { getMeteoToken } from '../../utils/auth';
import {
  getShipTrack,
  getShipDeduce,
  getAssembleRoutes,
  getTrajectoryByImo
} from '../../api/modules/proxy';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { toRaw } from 'vue';

export default defineComponent({
  name: 'ShipBar',
  components: {},
  props: {
    viewer: {
      type: Object,
      default: () => {
        return null;
      },
    },
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      },
    },
    clientHeight: {
      type: Number,
      default: () => {
        return null;
      },
    },
    currentNoonData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    allGroupListData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    hoverMmsi: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      // aisShipList: [],
      shipBillboards: [],
      shipNoonBillboards: [],
      shipInfoDetail: null,
      pastlineEntity: null,
      futurelineEntity: null,
      startPointEntity: null,
      endPointEntity: null,
      pastArrowPointEntity: [],
      futureArrowPointEntity: [],
      handler: null,
      currentName: '',
      formId: null,
      deduceData: [],
      animationLastPoint: null,
      deduceShipEntity: null,
      isInit: false, // 是否初始化label
      point: [], // 默认label的初始位置
      isVisible: false, // label是否展示
      popup: null, //弹窗
    };
  },
  mounted() {},
  beforeDestroy() {
    // clearInterval(this.timer)
  },
  computed: {
    ...mapGetters(['mmsi', 'aisShipList', 'timeGrid', 'noAisShipList', 'isPlay']),
    clientWidthScale() {
      return this.clientWidth / 1000;
    },
  },
  watch: {
    mmsi: function (newV, oldV) {
      if (!newV) {
        return false;
      }
      // 监听变化控制创建label
      if (this.noAisShipList.indexOf(newV) > -1) {
        if (this.shipInfoDetail) {
          this.viewer.removeEntity(this.shipInfoDetail);
        }
      } else {
        if (newV) {
          const shipObj =
            this.aisShipList.filter((item) => {
              return item.mmsi === newV;
            })[0] || {};
          const coord = [Number(shipObj.lon), Number(shipObj.lat)];
          const shipId = shipObj.mmsi;
          this.addShipLabel(this.viewer, coord, shipId, shipObj); // 船舶label
        } else {
          if (this.shipInfoDetail) {
            this.viewer.removeEntity(this.shipInfoDetail);
          }
        }
        const point =
          this.aisShipList.filter((item) => {
            return item.mmsi === newV;
          })[0] || {};
        this.currentName = point.name;
        // this.getTracjectory(point.imo)
        this.addShips(this.viewer, this.aisShipList);
        this.flyToShip(point);
        this.addShipInfo(newV);
        if (this.pastlineEntity) {
          this.viewer.removeEntity(this.pastlineEntity);
        }
        if (this.futurelineEntity) {
          this.viewer.removeEntity(this.futurelineEntity);
        }

        if (this.futureArrowPointEntity.length > 0) {
          this.futureArrowPointEntity.forEach((item) => {
            this.viewer.removeEntity(item);
          });
        }
        if (this.pastArrowPointEntity.length > 0) {
          this.pastArrowPointEntity.forEach((item) => {
            this.viewer.removeEntity(item);
          });
        }
        this.getTrackData(newV);
      }
    },
    timeGrid: function (newValue) {
      if (newValue) {
        const today = new Date();
        const today00 = new Date(today.setHours(0, 0, 0, 0));
        const date = moment(today00).add(newValue, 'h');
        const ts = date.unix() / 100;
        if (this.deduceData && this.deduceData.length > 0) {
          this.deduceShip(ts);
        }
      }
    },
    isPlay: function (newV) {
      if(newV) {
        this.createTimer()
      }else{
        this.removeTimer()
      }
    },
    // 暂时弃用
    hoverMmsi: function (newValue) {
      if (newValue) {
        const shipObj =
          this.aisShipList.filter((item) => {
            return item.mmsi === newValue;
          })[0] || {};
        const coord = [Number(shipObj.lon), Number(shipObj.lat)];
        const shipId = shipObj.mmsi;
        const shipName = shipObj.name;
        this.addShipLabel(this.viewer, coord, shipId, shipObj); // 船舶label
      } else {
        if (this.shipInfoDetail) {
          this.viewer.removeEntity(this.shipInfoDetail);
        }
      }
    },
    // 午报数据变化
    currentNoonData(newV) {
      this.addNoonShips(newV);
      let mmsi = this.mmsi;
      if (this.noAisShipList.indexOf(mmsi) > -1) {
        let shipObj = JSON.parse(JSON.stringify(newV)) || {};
        shipObj.name = this.allGroupListData.default_order.filter((item) => {
          return item.mmsi === mmsi;
        })[0].name;
        let coord = [Number(shipObj.lon), Number(shipObj.lat)];
        this.addShipLabel(this.viewer, coord, mmsi, shipObj); // 船舶label
        const point = shipObj;
        this.currentName = point.name;
        this.addNoonShips(newV);
        this.flyToShip(point);
        this.addShipInfo(mmsi);
        this.getTrackData(mmsi);
      }
    },
  },
  methods: {
    getTracjectory(imo) {
      getTrajectoryByImo(imo).then(res => {
        console.log('imo', res)
      })
    },
    getShipDeduceInfo() {
      getShipDeduce(this.formId).then((res) => {
        // console.log(res, 'res');
        if (res) {
          this.deduceData = res.data ? res.data : [];
        }
      });
    },

    createTimer() {
      this.viewer.setTimer()
    },
    removeTimer() {
      this.viewer.clearTimer()
    },
    deduceShip(ts) {
      let _diff = 0;
      let _index = 0;
      const deduceData = toRaw(this.deduceData);
      deduceData.forEach((item, index) => {
        const fts = new Date(item.format).getTime() / 100000;
        const diff = ts - fts > 0 ? ts - fts : fts - ts;
        if (index === 0) {
          _diff = diff;
          _index = 0;
        } else {
          _index = diff < _diff ? index : _index;
          _diff = diff < _diff ? diff : _diff;
        }
      });
      const currentPositon = deduceData[_index];

      // 计算船的角度
      let cog = currentPositon.cog * -1;
      cog = cog < 0 ? cog + 360 : cog;
      const radian = (cog * Math.PI) / 180;
      const url = './png/deduce-ship.svg';
      const scale = this.clientWidthScale;

      if(this.deduceShipEntity) {
        this.viewer.setEntityOptions(this.deduceShipEntity, {
          end: [Number(currentPositon.lon), Number(currentPositon.lat), 0],
          start: [...this.animationLastPoint],
          rotation: radian,
          isPlay: false//this.isPlay
        })
      }else {
        this.deduceShipEntity = this.viewer.addEntity({
          name: 'deduce-ship',
          position: Cartesian3.fromDegrees(
            Number(currentPositon.lon),
            Number(currentPositon.lat),
            0
          ),
          billboard: {
            image: url,
            // scale: scale,
            rotation: radian,
            scaleByDistance: new NearFarScalar(1, scale / 0.8, 2e7, scale / 3),
          },
        }, 'deduce-ship');
      }

      this.animationLastPoint = [Number(currentPositon.lon), Number(currentPositon.lat), 0]
      
    },
    addShips(viewer, data) {
      this.removeShipNoonEntities();
      this.removeShipEntities();
      this.destroyHandler();

      const shipsData = data || {};
      shipsData.forEach((item) => {
        const point = [Number(item.lon), Number(item.lat)];

        const shipSatus = item.aisNavStatusCn;
        let url = '';
        // 计算船的角度
        let cog = item.cog * -1;
        cog = cog < 0 ? cog + 360 : cog;
        let radian = 0;

        if (
          shipSatus === '发动机使用中' ||
          shipSatus.indexOf('在航') > -1 ||
          shipSatus.indexOf('航行中') > -1
        ) {
          url = './png/zaihang-green.png';
          radian = (cog * Math.PI) / 180;
        } else if (shipSatus === '锚泊') {
          url = './png/maopo-green.png';
        } else if (shipSatus === '漂航') {
          url = './png/piaohang-green.png';
        } else if (shipSatus === '系泊' || shipSatus.indexOf('靠泊') > -1) {
          url = './png/kaopo-green.png';
        } else {
          url = './png/zaihang-green.png';
          radian = (cog * Math.PI) / 180;
        }

        const west = Number(item.lon) - 2;
        const south = Number(item.lat) - 2;
        const east = Number(item.lon) + 2;
        const north = Number(item.lat) + 2;

        const scale = this.clientWidthScale;

        const billboard = this.viewer.addEntity({
          name: 'ship',
          position: Cartesian3.fromDegrees(
            Number(item.lon),
            Number(item.lat),
            0
          ),
          billboard: {
            image: url,
            // scale: scale,
            rotation: radian,
            scaleByDistance: new NearFarScalar(1, scale / 0.8, 2e7, scale / 3),
          },
        }, item.mmsi);
        this.shipBillboards.push({ id: item.mmsi, entity: billboard });
      });

      // this.clickShip();
      // this.hoverShip()
    },
    removeShipEntities() {
      this.shipBillboards.forEach((item) => {
        if (item && item.entity) {
          this.viewer.removeEntity(item.entity);
        }
      });
      this.shipBillboards = [];
    },
    // 添加午报时船的位置图标
    addNoonShips(data) {
      this.removeShipNoonEntities();
      this.destroyHandler();

      const shipsData = data || {};
      const url = './png/noon-status.png';
      const scale = this.clientWidthScale;
      const billboard = this.viewer.addEntity({
        name: 'ship_noon',
        position: Cartesian3.fromDegrees(
          Number(shipsData.lon),
          Number(shipsData.lat),
          0
        ),
        billboard: {
          image: url,
          // new CallbackProperty(getRotationValue, false)new Cesium.Color(1.0, 1.0, 1.0, 0.5)
          // scale: scale,
          rotation: 0,
          scaleByDistance: new NearFarScalar(1, scale / 0.8, 2e7, scale / 3),
        },
      }, shipsData.mmsi + 'noon');
      this.shipNoonBillboards.push({ id: shipsData.mmsi, entity: billboard });
    },
    // 删除历史图标
    removeShipNoonEntities() {
      this.shipNoonBillboards.forEach((item) => {
        if (item && item.entity) {
          this.viewer.removeEntity(item.entity);
        }
      });
      this.shipNoonBillboards = [];
    },
    flyToShip(point) {
      this.viewer.flyTo(point);
    },
    destroyHandler() {
      if (this.handler) {
        this.handler.destroy();
      }
    },
    addShipInfo(mmsi) {
      if (this.startPointEntity) {
        this.viewer.removeEntity(this.startPointEntity);
      }

      if (this.endPointEntity) {
        this.viewer.removeEntity(this.endPointEntity);
      }

      const shipObj =
        this.aisShipList.filter((item) => {
          return item.mmsi === mmsi;
        })[0] || {};
      // const coord = [Number(shipObj.lon), Number(shipObj.lat)];
      // const shipId = shipObj.mmsi
      // const shipName = shipObj.name
      // this.addShipLabel(this.viewer, coord, shipId, shipObj) // 船舶label
      // 添加起点
      if (shipObj.departure) {
        const departure = shipObj.departure;
        const departurePoint = [Number(departure.lon), Number(departure.lat)];
        const departureId = departure.id || departure.cName || departure.eName;
        const departurePort = departure.cName || departure.eName;
        this.addStartPoint(this.viewer, departurePoint, departureId, departurePort);
      }
      // 添加终点
      if (shipObj.destination) {
        const destination = shipObj.destination;
        const destinationPoint = [
          Number(destination.lon),
          Number(destination.lat),
        ];
        const destinationId =
          destination.id || destination.cName || destination.eName;
        const destinationPort = destination.cName || destination.eName;
        this.addEndPoint(this.viewer, destinationPoint, destinationId, destinationPort);
      }
    },
    // 格式化label数据
    addShipLabel(viewer, point, id, shipObj) {
      this.point = point;
      const wind =
        shipObj.meteo && shipObj.meteo.wind
          ? '风：' +
            shipObj.meteo.wind.pf +
            '级 / ' +
            shipObj.meteo.wind.direction
          : '--';
      const wave =
        shipObj.meteo && shipObj.meteo.wave
          ? '浪：' +
            this.delNum(shipObj.meteo.wave.sea.height) +
            ' m / ' +
            shipObj.meteo.wave.sea.direction
          : '--';
      const current =
        shipObj.meteo && shipObj.meteo.current
          ? '流：' +
            this.delNum(shipObj.meteo.current.knots) +
            ' knots / ' +
            shipObj.meteo.current.direction
          : '--';
      const content = {
        wind,
        wave,
        current,
      };
      //this.initTool(viewer.getContainer());
      // 经纬度坐标转为世界坐标再转为屏幕坐标
      //const position = viewer.pointToScreen([...point, 0])
      //this.showAt(position, shipObj.name, content);
      const contentHtml = this.createPopupContent(content)
      if(!this.popup) {
        this.popup = new CustomPopup(contentHtml, {
          showClose: true,
          title: shipObj.name,
          id: 'ship'
        }).addTo(this.viewer)
      }else{
        this.popup.setContent(contentHtml).setTitle(shipObj.name)
      }
      this.popup.setLngLat(point).show()
    },
    // 去除小数两位后的数值
    delNum(num) {
      // num = num.toString()
      // const index = num.indexOf('.')
      // console.log(index)
      // if (index > -1) {
      //   num = num.substring(0,index + 3)
      // }
      // console.log(num)
      return parseFloat(num).toFixed(2);
    },
    createPopupContent(content) {
      let contentHtml = document.createElement('div')
      contentHtml.setAttribute('style', 'width:200px;box-sizing:border-box;background: rgba(0, 0, 0, 0);font-size: 12px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;text-align: left;color: rgba(255, 255, 255, 0.89);line-height: 15px;word-break:break-all;')
      let windHtml = document.createElement('div')
      windHtml.setAttribute('style', 'padding: 10px 0 0 10px;')
      windHtml.innerText = content.wind
      contentHtml.appendChild(windHtml)

      let waveHtml = document.createElement('div')
      waveHtml.setAttribute('style', 'padding: 5px 0 5px 10px;')
      waveHtml.innerText = content.wave
      contentHtml.appendChild(waveHtml)

      let currentHtml = document.createElement('div')
      currentHtml.setAttribute('style', 'padding: 0 0 10px 10px;')
      currentHtml.innerText = content.current
      contentHtml.appendChild(currentHtml)

      return contentHtml
    },
    addStartPoint(viewer, point, id, name) {
      if (this.startPointEntity) {
        viewer.removeEntity(this.startPointEntity);
      }

      const scale = this.clientWidthScale / 2.8;
      const labelscale = this.clientWidthScale / 5;
      const labelOffset = this.clientWidthScale * 10;
      const padding = this.clientWidthScale * 6;

      this.startPointEntity = viewer.addEntity({
        id: id,
        position: Cartesian3.fromDegrees(point[0], point[1], 0),
        billboard: {
          image: './png/start-2x.png',
          scaleByDistance: new NearFarScalar(1, scale * 1.5, 2e7, scale),
          verticalOrigin: VerticalOrigin.BOTTOM,
        },
        label: {
          text: name,
          font: '30px sans-serif',
          fillColor: Color.WHITE,
          outlineColor: Color.WHITE,
          horizontalOrigin: HorizontalOrigin.LEFT,
          verticalOrigin: VerticalOrigin.BOTTOM,
          showBackground: true,
          backgroundColor: Color.fromBytes(240, 211, 104, 255),
          backgroundPadding: new Cartesian2(padding, padding),
          pixelOffset: new Cartesian2(labelOffset, -15),
          scaleByDistance: new NearFarScalar(1, labelscale * 1.5, 2e7, labelscale)
        }
      });
    },
    addEndPoint(viewer, point, id, name) {
      if (this.endPointEntity) {
        viewer.removeEntity(this.endPointEntity);
      }
      const scale = this.clientWidthScale / 2.8;
      const labelscale = this.clientWidthScale / 5;
      const labelOffset = this.clientWidthScale * 10;
      const padding = this.clientWidthScale * 6;

      this.endPointEntity = viewer.addEntity({
        id: id,
        position: Cartesian3.fromDegrees(point[0], point[1], 0),
        billboard: {
          image: './png/end-2x.png',
          scaleByDistance: new NearFarScalar(1, scale * 1.5, 2e7, scale),
          verticalOrigin: VerticalOrigin.BOTTOM,
        },
        label: {
          text: name,
          font: '30px sans-serif',
          fillColor: Color.WHITE,
          outlineColor: Color.WHITE,
          horizontalOrigin: HorizontalOrigin.LEFT,
          verticalOrigin: VerticalOrigin.BOTTOM,
          showBackground: true,
          backgroundColor: Color.fromBytes(24, 184, 212, 255),
          backgroundPadding: new Cartesian2(padding, padding),
          pixelOffset: new Cartesian2(labelOffset, -15),
          scaleByDistance: new NearFarScalar(1, labelscale * 1.5, 2e7, labelscale)
        }
      });
    },
    async getTrackData(mmsi) {
      this.formId = null;
      if (this.futurelineEntity) {
        this.viewer.removeEntity(this.futurelineEntity);
      }
      if (this.pastlineEntity) {
        this.viewer.removeEntity(this.pastlineEntity);
      }
      /**if (!getMeteoToken()) {
        await store.dispatch('GET_METEO_TOKEN');
      }**/
      await getShipTrack(mmsi).then((res) => {
        const data = res.data;
        this.formId = data.formId;
        if (this.formId) {
          this.getShipDeduceInfo();
        }
      });
      if (!this.formId) {
        return;
      }
      getAssembleRoutes({ formId: this.formId }).then((res) => {
        const data = res.data;
        if(!data) {
          return
        }
        const future = data.future || []
        const past = data.past || []
        if(future.length > 1) {
          if(past.length > 0) {
            future.unshift(past[past.length - 1])
          }
          const futurePoints = future.map(item => {
            if(item.lon && item.lat) {
              return [item.lon, item.lat, 100]
            }
          }).reduce((a, b) => a.concat(b))

          this.addfutureline(this.viewer, futurePoints);
        }
        
        if(past.length > 1) {
          const pastPoints = past.map(item => {
            if(item.lon && item.lat) {
              return [item.lon, item.lat, 100]
            }
          }).reduce((a, b) => a.concat(b))
          this.addpastline(this.viewer, pastPoints)
        }
      });
    },
    addpastline(viewer, data) {
      if (!data || data.length === 0) {
        return;
      }

      const width = this.clientWidthScale * 1.5;
      const outlineWidth = this.clientWidthScale / 2;

      this.pastlineEntity = viewer.addEntity({
        name: 'ship past line',
        polyline: {
          positions: Cartesian3.fromDegreesArrayHeights(data),
          width: width,
          material: new PolylineOutlineMaterialProperty({
            color: new Color.fromBytes(231, 193, 44, 255),
            outlineColor: new Color.fromBytes(1, 18, 41, 127),
            outlineWidth: outlineWidth,
          })
        },
      })
    },
    addfutureline(viewer, data) {
      if (!data || data.length === 0) {
        return;
      }
      const width = this.clientWidthScale * 1.5;
      const outlineWidth = this.clientWidthScale / 2;
      const dashLength = this.clientWidthScale * 6;

      /**this.futurelineEntity = viewer.addPolyline({
        type: 'dash',
        positions: {
          hasHeight: true,
          value: data
        },
        width: width,
        color: 'rgba(25, 197, 255, 1)',
        dashLength: dashLength,
        outlineColor: 'rgba(1, 18, 41, 0.5)',
        outlineWidth: outlineWidth,
      }, 'ship-future-line')**/

      this.futurelineEntity = viewer.addEntity({
        name: 'ship future line',
        polyline: {
          positions: Cartesian3.fromDegreesArrayHeights(data),
          width: width,
          material: new PolylineDashMaterialProperty({
            color: new Color.fromBytes(25, 197, 255, 255)
          })
        },
      });
    },
    addpastArrows(viewer, points) {
      if (this.pastArrowPointEntity.length > 0) {
        this.pastArrowPointEntity.forEach((item) => {
          viewer.removeEntity(item);
        });
      }
      this.pastArrowPointEntity = [];

      points.forEach((item) => {
        const url = './png/arrow-red.png';
        const scale = this.clientWidthScale / 2;
        if (item.point && item.point[1]) {
          const pastArrowPointEntity = viewer.addEntity({
            position: Cartesian3.fromDegrees(item.point[0], item.point[1], 0),
            billboard: {
              image: url,
              scale: scale,
              rotation: item.radian,
            },
          });
          this.pastArrowPointEntity.push(pastArrowPointEntity);
        }
      });
    },
    addfutureArrows(viewer, points, type) {
      if (this.futureArrowPointEntity.length > 0) {
        this.futureArrowPointEntity.forEach((item) => {
          viewer.removeEntity(item);
        });
      }
      this.futureArrowPointEntity = [];

      points.forEach((item) => {
        const url = './png/arrow-blue.png';
        const scale = this.clientWidthScale / 2;
        if (item.point && item.point[1]) {
          const futureArrowPointEntity = viewer.addEntity({
            position: Cartesian3.fromDegrees(item.point[0], item.point[1], 0),
            billboard: {
              image: url,
              scale: scale,
              rotation: item.radian,
            },
          });
          this.futureArrowPointEntity.push(futureArrowPointEntity);
        }
      });
    },
  },
});
</script>

<style lang="scss">
@import '../../styles/variables';
.label-close {
  background-color: #f00;
}
@media screen and (max-width: 1500px) {
  .ship-info-container {
    position: absolute;
    top: 50%;
    left: 350px;

    .label {
      position: absolute;
      left: 52px;
      top: 8px;
      color: #ffffff;
      font-size: 10px;
      text-align: left;
      display: flex;
      height: 30px;
      align-items: center;
    }

    .ship-info-icon {
      width: 140px;
    }
  }
}
@media screen and (min-width: 1501px) {
  .ship-info-container {
    position: absolute;
    top: 50%;
    left: 25%;

    .label {
      position: absolute;
      left: 58px;
      top: 10px;
      color: #ffffff;
      font-size: 12px;
      text-align: left;
      display: flex;
      height: 32px;
      align-items: center;
    }

    .ship-info-icon {
      width: 160px;
    }
  }
}
@media screen and (min-width: 1921px) {
  .ship-info-container {
    position: absolute;
    top: 50%;
    left: 26%;

    .label {
      position: absolute;
      left: 100px;
      top: 30px;
      color: #ffffff;
      font-size: 22px;
      text-align: left;
      display: flex;
      height: 44px;
      align-items: center;
    }

    .ship-info-icon {
      width: 300px;
    }
  }
}
@media screen and (min-width: 2561px) {
  .ship-info-container {
    position: absolute;
    top: 50%;
    left: 24%;

    .label {
      position: absolute;
      left: 100px;
      top: 30px;
      color: #ffffff;
      font-size: 22px;
      text-align: left;
      display: flex;
      height: 44px;
      align-items: center;
    }

    .ship-info-icon {
      width: 300px;
    }
  }
}
@media screen and (min-width: 6000px) {
  .ship-info-container {
    position: absolute;
    /* margin-top: 100px; */
    top: 50%;
    left: 1600px;

    .label {
      position: absolute;
      left: 190px;
      top: 36px;
      color: #ffffff;
      font-size: 44px;
      text-align: left;
      display: flex;
      height: 88px;
      align-items: center;
    }

    .ship-info-icon {
      width: 500px;
    }
  }
}
</style>
